import {useCallback, useState} from 'react';

import {saveHubspotCredentials} from 'src/openapi/admin/apis/HubspotControllerApi';
import {useAppDispatch} from 'src/store/hooks';
import {getError} from 'src/utils/get-error';

import {getConnectionErrorMessage} from '../../utils/getDuplicatesErrorMessage';

type Props = {
    onSuccess: () => void,
    onFailure: (error: string) => void,
};

export const useSaveHubspotAuth = ({onSuccess, onFailure}: Props) => {
    const apiDispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const action = useCallback(async (actionProps: {authorizationCode: string, accountId: number}) => {
        setIsLoading(true);
        const {authorizationCode, accountId} = actionProps;

        const saveAuthResponse = await apiDispatch(saveHubspotCredentials({
            authorizationCode,
            accountId,
        }));
        if (saveAuthResponse.payload.success && saveAuthResponse.payload.data.type?.code === 'dup') {
            onFailure(getConnectionErrorMessage(saveAuthResponse.payload.data));
        } else if (saveAuthResponse.payload.success) {
            onSuccess();
        } else {
            onFailure(getError({error: saveAuthResponse.payload.data, separator: ' '}));
        }
        setIsLoading(false);
    }, [onSuccess, onFailure, apiDispatch]);

    return {isLoading, action};
};
